import React from 'react';

/**
 * ConsultantDashboardPendingRequestsBanner
 *
 * Props:
 * - pendingRequests: number
 * - onViewRequests: () => void
 */
const ConsultantDashboardPendingRequestsBanner = ({
  pendingRequests,
  onViewRequests
}) => {
  if (!pendingRequests || pendingRequests <= 0) return null;

  return (
    <div className="bg-gradient-to-r from-orange-50 to-yellow-50 dark:from-orange-900/20 dark:to-yellow-900/20 border-l-4 border-orange-500 dark:border-orange-400 p-4 mb-8 rounded-r-lg shadow-sm">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className="flex-shrink-0">
            <svg
              className="h-6 w-6 text-orange-600 dark:text-orange-400 animate-pulse"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
              />
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-semibold text-orange-900 dark:text-orange-200">
              {pendingRequests} Pending Session Request
              {pendingRequests > 1 ? 's' : ''}
            </h3>
            <p className="text-xs text-orange-700 dark:text-orange-300 mt-1">
              {pendingRequests > 1 ? 'Users are' : 'A user is'} waiting for you to
              start their assessment session
            </p>
          </div>
        </div>
        <button
          onClick={onViewRequests}
          className="ml-4 px-4 py-2 bg-orange-600 hover:bg-orange-700 dark:bg-orange-700 dark:hover:bg-orange-600 text-white rounded-lg text-sm font-medium transition-colors flex items-center"
        >
          <span>View Requests</span>
          <svg
            className="w-4 h-4 ml-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 5l7 7-7 7"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ConsultantDashboardPendingRequestsBanner;


